import AlgorithmTable from './AlgorithmTable';

export default AlgorithmTable;
